// Copyright (c) 2019 Celadon Development LLC, All rights reserved.
// Author Yana Sidorova <yana.sidorova@celadon.ae>
import { all } from 'redux-saga/effects';

import loginSagas from '../pages/login/store/sagas';
import registerSagas from '../pages/register/store/sagas';
import ordersSagas from '../pages/account/components/AccountTab/components/MyOrders/store/sagas';
import profileSagas from '../pages/account/components/AccountTab/components/MyProfile/store/sagas';
import searchAddressSagas from
  '../pages/account/components/AccountTab/components/Address/store/sagas';
import orderDetailsSagas from
  '../pages/account/components/AccountTab/components/OrderFull/store/sagas';
import basketSagas from '../pages/basket/store/sagas';
import homeSagas from '../pages/home/store/sagas';
import contactSagas from '../pages/contact/store/sagas';
import confirmOrderSagas from '../pages/choose-delivery/store/sagas';
import forgotPasswordSagas from '../pages/forgot-password/store/sagas';
import parcelShopsSagas from '../pages/find-parcel-shop/store/sagas';
import packGuidelinesSagas from '../pages/packaging-guidelines/store/sagas';
import howItWorksSagas from '../pages/howitworks/store/sagas';
import faqsSagas from '../pages/faqs/store/sagas';
import privacyPolicySagas from '../pages/privacy-policy/store/sagas';
import termsAndConditionsSagas from '../pages/terms-and-conditions/store/sagas';
import qualityGuidelinesSagas from '../pages/guidelines/store/sagas';
import arrangeCollectionSagas from '../pages/arrange-collection/store/sagas';
import fundraiseSagas from '../pages/fundraise/store/sagas';
import getPaidSagas from '../pages/get-paid/store/sagas';
import vouchersSagas from
  '../pages/account/components/AccountTab/components/Vouchers/store/sagas';
import issueVoucherSagas from '../pages/issue-voucher/store/sagas';
import customerOverviewSagas from
  '../pages/account/components/AccountTab/components/CustomerOverview/store/sagas';
import voucherConfirmedSagas from '../pages/voucher-confirmed/store/sagas';
import voucherDetailsSagas from
  '../pages/account/components/AccountTab/components/VoucherDetails/store/sagas';
import redeemVoucherSagas from '../pages/redeem-voucher/store/sagas';

export default function* root() {
  yield all([...loginSagas]);
  yield all([...ordersSagas]);
  yield all([...basketSagas]);
  yield all([...registerSagas]);
  yield all([...homeSagas]);
  yield all([...contactSagas]);
  yield all([...profileSagas]);
  yield all([...confirmOrderSagas]);
  yield all([...forgotPasswordSagas]);
  yield all([...orderDetailsSagas]);
  yield all([...searchAddressSagas]);
  yield all([...parcelShopsSagas]);
  yield all([...packGuidelinesSagas]);
  yield all([...howItWorksSagas]);
  yield all([...faqsSagas]);
  yield all([...privacyPolicySagas]);
  yield all([...termsAndConditionsSagas]);
  yield all([...qualityGuidelinesSagas]);
  yield all([...arrangeCollectionSagas]);
  yield all([...fundraiseSagas]);
  yield all([...getPaidSagas]);
  yield all([...vouchersSagas]);
  yield all([...issueVoucherSagas]);
  yield all([...customerOverviewSagas]);
  yield all([...voucherConfirmedSagas]);
  yield all([...voucherDetailsSagas]);
  yield all([...redeemVoucherSagas]);
}
